import { InjectionToken, Type } from '@angular/core';

export interface MapNavigationHandler {
	/** Navigiert zur Detailansicht eines Punktes */
	navigateToDetail(id: string): void;

	/** Navigiert zur Detailansicht einer Fläche/eines Polygons (optional) */
	navigateToPolygonDetail?(id: string): void;

	/** Navigiert zur Multi-Print-Ansicht */
	navigateToPrintView(ids: string[]): void;

	/** Standalone-Component für die Symbol-Legende (wird als Modal geöffnet) */
	legendComponent?: Type<any>;

	/** Hilfetext für Filter-Dialog (z.B. "Typ, Status, Bearbeiter, Datum") */
	getFilterHelpText(): string;
}

export const MAP_NAVIGATION_HANDLER = new InjectionToken<MapNavigationHandler>(
	'MAP_NAVIGATION_HANDLER'
);
